import React, { Component } from 'react';
import {connect} from 'react-redux';
import { startLevel } from '../../store/actions';
import GameLayout from '../../styled/GameLayout';
import Container from '../../styled/Container';
import ImageContainer from '../../styled/ImageContainer';
import TitleContainer from '../../styled/TitleContainer';
import TextContainer from '../../styled/TextContainer';
import SuperButton from '../SuperButton';
import Share from '../Share'
import { inflect } from '../../utils';
import * as S from '../../store/selectors';
import { GAGameRestart } from "../../analytics.js";

export default
@connect(state => {
  return {
    level: state.game.level,
    final: S.final(state),
  }
})
class WellCome extends Component {
  render() {
    return (
      <GameLayout justifyContent='flex-start'>
        <ImageContainer 
          src={this.props.final.image}
        />
        <Container margin={'40px 0 0 0'}>
          {
            this.props.win
              ? (<TitleContainer>Мною разгаданы все аббревиатуры</TitleContainer>)
              : (<TitleContainer>Мною разгаданы {this.props.level} из 10 аббревиатур</TitleContainer>)
          }
          
        </Container>
        <Container margin={'19px 0 0 0'} width='410px'>
          <TextContainer>{this.props.final.text.split('/n').map((line, idx) => <p key={idx}>{line}</p>)}</TextContainer>
        </Container>
        <Share params={[['level', this.props.level]]}/>
        <Container margin={'20px 0 50px 0'} padding={'0 0 0 0'}>
          <SuperButton
            width={'280px'}
            height={'50px'}
            onClick={() => {
              GAGameRestart(this.props.level);
              this.props.dispatch(startLevel(0));
            }}
          >Играть ещё раз</SuperButton>
        </Container>
      </GameLayout>
    );
  }
}
